import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { getUserInfo } from '../services/auth';

const UnauthorizedPage = () => {
  const navigate = useNavigate();
  const userInfo = getUserInfo();

  return (
    <UnauthorizedContainer>
      <UnauthorizedCard>
        <IconContainer>
          <LockIcon />
        </IconContainer>
        
        <h1>Access Denied</h1>
        <p>
          You don't have permission to access this page. 
          This area requires additional privileges.
        </p>
        
        <ButtonGroup>
          <PrimaryButton onClick={() => navigate('/')}>
            Return to Dashboard
          </PrimaryButton>
          
          {userInfo && userInfo.isStaff && (
            <SecondaryButton onClick={() => navigate('/patients')}>
              Go to Patients
            </SecondaryButton>
          )}
        </ButtonGroup>
        
        <HelpText>
          If you believe you should have access to this page, 
          please contact your administrator.
        </HelpText>
      </UnauthorizedCard>
    </UnauthorizedContainer>
  );
};

// Lock Icon Component
const LockIcon = () => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    viewBox="0 0 24 24" 
    fill="currentColor" 
    width="48" 
    height="48"
  >
    <path 
      fillRule="evenodd" 
      d="M12 1.5a5.25 5.25 0 00-5.25 5.25v3a3 3 0 00-3 3v6.75a3 3 0 003 3h10.5a3 3 0 003-3v-6.75a3 3 0 00-3-3v-3c0-2.9-2.35-5.25-5.25-5.25zm3.75 8.25v-3a3.75 3.75 0 10-7.5 0v3h7.5z" 
      clipRule="evenodd" 
    />
  </svg>
);

// Styled Components
const UnauthorizedContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: var(--gray-100);
`;

const UnauthorizedCard = styled.div`
  width: 100%;
  max-width: 500px;
  padding: 2.5rem;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  text-align: center;
  
  h1 {
    margin-top: 1.5rem;
    margin-bottom: 1rem;
    font-size: 1.5rem;
    font-weight: 600;
    color: var(--gray-800);
  }
  
  p {
    margin-bottom: 2rem;
    color: var(--gray-600);
    font-size: 1rem;
    line-height: 1.5;
  }
`;

const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 80px;
  height: 80px;
  margin: 0 auto;
  background-color: #fee2e2;
  border-radius: 50%;
  color: #b91c1c;
`;

const ButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-bottom: 1.5rem;
`;

const PrimaryButton = styled.button`
  width: 100%;
  padding: 0.75rem;
  background-color: var(--primary-600);
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
  
  &:hover {
    background-color: var(--primary-700);
  }
`;

const SecondaryButton = styled.button`
  width: 100%;
  padding: 0.75rem;
  background-color: white;
  color: var(--primary-600);
  border: 1px solid var(--primary-600);
  border-radius: 4px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  
  &:hover {
    background-color: var(--primary-50);
  }
`;

const HelpText = styled.p`
  font-size: 0.875rem;
  color: var(--gray-500);
`;

export default UnauthorizedPage;
